import React from 'react';
import PropTypes from 'prop-types';
import InsightsWithSections
  from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/MainContentPicker/MainContentDefault/LeftSide/TabsPicker/Tabs/TabContentPicker/TabContent/Content/TabLayouts/Insights/Default';
import Default from './TabLayouts/Default';

function getTabLayout(coll) {
  switch (coll.meta().type()) {
    case 'facetPlanProposalScenarioInsights': {
      return InsightsWithSections;
    }
    default:
      return Default;
  }
}

const TabContent = ({
  collection,
}) => {
  const [outerResource] = collection;
  const resourcesCollection = outerResource.attr('resources');
  const Component = getTabLayout(resourcesCollection);

  return (
    <Component
      collection={collection}
      resourcesCollection={resourcesCollection}
    />
  );
};

TabContent.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default TabContent;
